import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';

import ProductTemplate from '../../components/productmng/ProductTemplate';

import {
  unloadProduct,
  viewProduct,
} from '../../modules/productModule/product';

import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import ProductInfoContainer from './ProductInfoContainer';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import AskDialog from '../../components/common/dialog/AskDialog';
import * as productApi from '../../lib/api/product';

const ProductContainer = () => {
  const { id } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState(null);

  //처음 마운트 될 때 partenr 데이터 요청
  const dispatch = useDispatch();
  const { product, error, loading } = useSelector(
    ({ productModule, loading }) => ({
      product: productModule.product.product,
      error: productModule.product.error,
      loading: loading['product/VIEW_PRODUCT'],
    }),
  );

  useEffect(() => {
    dispatch(viewProduct(id));

    //언마운트될때 리덕스에서 파트너 데이터 초기화
    return () => {
      dispatch(unloadProduct());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (product) {
      let title = {
        name: `[${product.productLine}] ${product.productNm}`,
        no: product.prouductUuid,
      };
      setTitleData(title);
    }
  }, [product]);

  const handleGoBack = () => {
    navigate('/productmng');
  };

  const handleEdit = () => {
    navigate(`/productmng/${id}/edit`);
  };

  const [removeVisible, setRemoveVisible] = useState(false);
  const handleRemove = () => {
    setRemoveVisible(true);
  };
  const onRemoveCancle = () => {
    setRemoveVisible(false);
  };
  const onRemoveConfirm = () => {
    //제품 삭제
    onRemove();
    setRemoveVisible(false);
  };

  const onRemove = async () => {
    try {
      const response = await productApi.removeProduct(id);
      if (response.data.result === 'success') {
        enqueueSnackbar('삭제 되었습니다', {
          variant: 'error',
        });
        handleGoBack();
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <ProductTemplate product={product} loading={loading} error={error}>
      <TitleBox
        edit
        remove
        handleGoBack={handleGoBack}
        menuName="제품관리/제품 관리/상세보기"
        menuLink="/productmng"
        icon="product"
        titleData={titleData}
        handleEdit={handleEdit}
        handleRemove={handleRemove}
      />
      <DetailTemplate title="기본정보">
        <ProductInfoContainer product={product} />
      </DetailTemplate>

      <AskDialog
        visible={removeVisible}
        title="제품 삭제"
        description="해당 제품을  삭제 처리 하시겠습니까?(복구 불가)"
        onConfirm={onRemoveConfirm}
        onCancle={onRemoveCancle}
      />
    </ProductTemplate>
  );
};

export default ProductContainer;
